<template>
  <div>
    <channel-field>
      <div slot="label">Bot Name:</div>
      <div slot="value">{{ channel.telegram.name }}</div>
    </channel-field>

    <channel-field class="mt-3">
      <div slot="label">Bot Username:</div>
      <div slot="value">{{ channel.telegram.username }}</div>
    </channel-field>

    <channel-field class="mt-3">
      <div slot="label">URI:
        <span id="uri_info" v-b-popover:uri_info.html.hover.right="uriPopoverText">
          <icon name="info-circle"></icon>
        </span>
      </div>

      <div slot="value">
         <a :href="`https://telegram.me/${channel.telegram.username}`" target="_blank">
          https://telegram.me/{{ channel.telegram.username }}
        </a>
      </div>

    </channel-field>

    <channel-field class="mt-3 align-items-center">
      <div slot="label">Token:
      </div>
      <div slot="value">
        <sensitive-field :text="channel.telegram.access_token" readonly/>
      </div>
    </channel-field>
  </div>
</template>

<script>
  import ChannelDetailField from '@/components/administration/common/Field'
  import 'vue-awesome/icons/info-circle'
  import SensitiveField from '@/components/common/SensitiveField'

  const uriPopoverText = 'Use this URI for Telegram links. ' +
    'You can also use params <b>start</b> or <b>startgroup</b>.' +
    '<br/><br/>For more info see <a href="https://core.telegram.org/bots#deep-linking" target="_blank">Telegram documentation</a>.'

  export default {
    components: {
      'channel-field': ChannelDetailField,
      SensitiveField
    },

    store: {
      channel: 'administration.channelDetail.channel'
    },

    data() {
      return {
        uriPopoverText
      }
    }
  }
</script>
